export default "__VITE_ASSET__763815f9__"